import { getAnimations } from './utils/animations';
export var skeletonStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var animations = getAnimations(v.animationBackground, v.animationBackgroundSecondary);
    return Object.assign({
      width: '100%'
    }, p.animation && animations[p.animation]);
  }
};